module.exports = __webpack_public_path__ + "img/ic_otm.063dfbc4.svg";